module.exports = __webpack_public_path__ + "static/media/IT@2x.fcf09975.png";